export enum FestiveMode {
  None = ``,
  PartyCorgi = `party-corgi`,
  Winter = `winter`,
  Luv = `luv`,
  HorseRun = `horse-run`,
}

let _festiveMode: FestiveMode = FestiveMode.None;

export function setFestiveMode(value: FestiveMode) {
  _festiveMode = value;
}

export function getFestiveMode(): FestiveMode {
  return _festiveMode;
}
